/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import { IPatientDetail } from "@curefit/care-common";
import { PatientDetailContainer, LeftWrapper, PatientName, RightWrapper, Info, iconStyle, Seperator, backIconStyle } from "./styles";
import AppUtils from "../../../utils/AppUtils";

interface IPatientInfoProps {
    patientInfo: IPatientDetail;
    handleBackAction: () => void;
}


export const PatientInformation: React.FC<IPatientInfoProps> = (props: IPatientInfoProps) => {
    const { patientInfo: { name, gender, formattedAge }, handleBackAction } = props;

    const patientAge = AppUtils.getFormattedAgeToDisplay(formattedAge);

    return (
        <PatientDetailContainer>
            <LeftWrapper>
                <img src="/images/back-arrow.svg" alt="back" css={backIconStyle} onClick={handleBackAction} />
                <div>
                    <PatientName>{name}
                        <img className="patient-info-icon" src="/images/icons/info-grey.svg" css={iconStyle} />
                    </PatientName>
                    <div>
                        <Info>{patientAge} <Seperator> | </Seperator> </Info>
                        <Info>{gender}</Info>
                    </div>
                </div>
            </LeftWrapper>
            {/* <RightWrapper onClick={exitPatientTemplate}>
                <img className="force-close-icon" src="/images/icons/grey-cancel.png" css={iconStyle} />
                Exit?
            </RightWrapper> */}
        </PatientDetailContainer>
    )
}